import React, { useState } from "react";

// Styles
import MorningMeetingModalContainer from "./MorningMeetingModal.styles";

// Utils
import { useSettings } from "context/Settings.context";

// Components
import Button from "components/Common/Button/Button";
import Modal from "components/Common/Modal/Modal";
import { MorningMeetingForm } from "./MorningMeetingModal.types";
import TextField from "../../../components/Common/TextField/TextField";
import SelectDate from "../../../components/Screens/BQMQ/Setup/SelectDate/SelectDate";
import { applyTimeZoneOffset } from "../../../utils/common.utils";

interface Props {
    onClose: () => void;
    onSubmit: (formValue: MorningMeetingForm) => void;
    title?: string;
    meetingTitle?: string;
    meetingDate?: Date;
}

const MorningMeetingModal = ({
    onClose,
    onSubmit,
    title = "NEW MEETING",
    meetingTitle,
    meetingDate,
}: Props) => {
    const { setToast } = useSettings();
    const [meeting, setMeeting] = useState<MorningMeetingForm>({
        title: meetingTitle || `GEF Morning Meeting`,
        date: meetingDate || null,
    });
    // It's not enough to provide SelectDate with a default date (if provided) in order to display the prefilled value.
    // An event must also be created.
    const [eventArray, setEventArray] = useState<any[]>(
        meetingDate
            ? [
                  {
                      title: `> ${applyTimeZoneOffset(meetingDate, "HH:mm")}: ${
                          meeting.title
                      }`,
                      start: meetingDate,
                      end: meetingDate,
                      allDay: true,
                  },
              ]
            : []
    );

    const isFormValid = (): boolean => {
        if (!meeting.title) {
            setToast({
                show: true,
                type: "error",
                message: "Please enter a title",
            });

            return false;
        }

        if (!meeting.date) {
            setToast({
                show: true,
                type: "error",
                message: "Please select meeting date",
            });

            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (isFormValid()) {
            onSubmit(meeting);
        }
    };

    return (
        <MorningMeetingModalContainer>
            <Modal width={"58vw"} onClose={onClose}>
                <div className="main">
                    <div className="text">
                        <h3>{title}</h3>
                    </div>
                    <TextField
                        placeholder={"Meeting title"}
                        change={(val: string) => {
                            setMeeting({
                                ...meeting,
                                title: val,
                            });
                        }}
                        value={meeting.title}
                    />
                    <SelectDate
                        company={null}
                        date={meeting.date}
                        setDate={(date: Date) => {
                            setMeeting({
                                ...meeting,
                                date: date,
                            });
                        }}
                        eventArray={eventArray}
                        setEventArray={setEventArray}
                        scheduledEvents={[]}
                        title={meeting.title || "Meeting"}
                    />
                </div>

                <div className="actions">
                    <Button text="CANCEL" color="flat" click={onClose} />
                    <Button text="SAVE" click={() => handleSubmit()} />
                </div>
            </Modal>
        </MorningMeetingModalContainer>
    );
};
export default MorningMeetingModal;
